import * as React from 'react';
import Slider from 'react-slick';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { GetImageUrl, newI18n } from '../core/index';
import { CMS, RouterData } from '../shared/index';
import { getContentFronStorage } from '../utils/index';
export interface Homesection6Props extends BaseComponentProps {
	lang: string;
	currency: string;
	history: RouterData.History | any;
}
export interface Homesection6State extends BaseComponentState {
	data: CMS.CmsBlog[];
	// titleAndDescription: CMS.CmsPavoriteDestinationsZones;
	requesting: boolean;
}

export class Homesection6 extends BaseComponent<Homesection6Props, Homesection6State> {

	imageUrl = GetImageUrl();
	// titleAndDescription: CMS.CmsPavoriteDestinationsZones;

	translation = {
		Title: newI18n("HOME.BLOG.Title", "About Bali"),
		SubTitle: newI18n("HOME.BLOG.SubTitle", " Read our guides to the best hotels in Bali. Out team of experts have sifted through the hundreds of hotels in Bali to bring a range of personal recommendations. Luxury, beachfront, family friendly hotels - you’ll find the best of the best right here."),
	};
	
	/*
titleAndDescription: {
				title: 'About Bali',
				description: 'Read our guides to the best hotels in Bali. Out team of experts have sifted through the hundreds of hotels in Bali to bring a range of personal recommendations. Luxury, beachfront, family friendly hotels - you’ll find the best of the best right here.'
			},
	*/
	constructor(props: Homesection6Props) {
		super(props);
		this.state = {
			data: [],
			
			requesting: true
		};

	}

	componentDidMount() {
		this.getLoc();
	}
	componentDidUpdate(prevProps: Homesection6Props, prevState: Homesection6State) {
		if (prevProps.lang !== this.props.lang) {
			this.getLoc();
		}
	}

	getLoc: () => any = () => {
		getContentFronStorage(this.props.lang, "CmsBlog").then(
			(d: any[]) => {
				this.setState({ data: d, requesting: false });
			}).catch((exc) => { console.error('error: ', exc); });
		 
	}
	render() {
		if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
		var settings = {
			dots: false,
			infinite: true,
			speed: 1500,
			slidesToShow: 4,
			slidesToScroll: 4,
			autoplay: true,
			autoplaySpeed: 5000,
			responsive: [{
				breakpoint: 1400,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 4,
					infinite: true,
					dots: true
				}
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: true,
					dots: true
				}
			}, {
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					initialSlide: 2
				}
			}, {
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}]
		};

		let slide: any[] = [];

		if (this.state.requesting === true) {
			slide.push(<span key='spacer_undefined_data' />);
		} else {
			let lop = 0;
			if (this.state.data.length > 0) {
				for (let apokadenne of this.state.data) {
					lop++;
					let img = <img alt="" src={`${this.imageUrl}/blog/thumb/` + apokadenne.thumbUrl} className="img-responsive" />;
					if (apokadenne.thumbUrl!.substring(0, 4) === 'http') {
						img = <img alt="" src={`${apokadenne.thumbUrl}`} className="img-responsive" />;
					}
					slide.push(

						<div
							key={lop + ''}
							data-appears-class="fadeIn"
							onClick={() => {
								this.props.history.push("/" + apokadenne.slug, []);
							}}
						>
							<div className="figure-wrapper" style={{ padding: '0px 5px' }}>
								<figure className="effect-zoe">
									{img}
								</figure>
								<h4>{apokadenne.name}</h4>
								{apokadenne.shortDescription}
							</div>
						</div>

					);
				}
			}

		}

		let renderDesctiption = (x: any) => {
			return { __html: x };
		}; 
		return (
			<section className="container-fluid container-fullw" style={{ fontWeight: 500, paddingBottom: 0, borderBottom: 0 }}>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h2 className="text-center" style={{ fontWeight: 500 }} >{this.translation.Title} </h2>
							<hr />
							<p className="text-center " data-appears-class="fadeInDown" data-appears-delay="300" dangerouslySetInnerHTML={renderDesctiption(this.translation.SubTitle)} />
							<div className="row">
								<div data-appears-group-delay="0" data-appears-delay-increase="200">
									<Slider {...settings}>
										{slide}
									</Slider>
									<span />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

		);
	}
}

/* 
*/


// WEBPACK FOOTER //
// ./src/home/Homesection6.tsx